// extracted by mini-css-extract-plugin
module.exports = {"icon":"e_Gw","container":"e_Hw","overlay":"e_Iw"};